<template>
  <div class="filter">
    <div class="filterBox">
      <div class="filterBar">
        <p @click="() => (showBottom = !showBottom)">{{ lang('筛选') }}</p>
        <img class="image" src="../../../assets/images/score/drop.png" />
      </div>
      <van-popup
        v-model:show="showBottom"
        round
        position="bottom"
        :style="{ height: '90%' }"
        @click-overlay="overlay"
      >
        <div style="display: flex; flex-direction: column; height: 100%">
          <div class="filterMain">
            <div class="searchBox">
              <p style="font-size: 14px">{{ lang('运单编码') }}</p>
              <div class="search">
                <input
                  v-model="searchText"
                  class="searchInput"
                  :placeholder="lang('请输入运单编码')"
                />
                <van-icon
                  v-if="searchText"
                  class="icon"
                  name="clear"
                  @click="() => (searchText = '')"
                />
              </div>
            </div>
            <FilterBtn
              :name="lang('订单来源')"
              :index="source"
              :list="props.sourceEnum"
              @click="sourceFn"
            />
            <FilterBtn
              :name="lang('订单来源类型')"
              :index="sourceType"
              :list="props.sourceEnumType"
              @click="sourceTypeFn"
            />
            <div class="dateBox">
              <van-radio-group v-model="checked" direction="horizontal">
                <van-radio name="1" checked-color="#E60012">{{
                  lang('寄件日期')
                }}</van-radio>
                <van-radio name="2" checked-color="#E60012">{{
                  lang('入库日期')
                }}</van-radio>
              </van-radio-group>
              <van-picker-group
                class="group"
                :show-toolbar="false"
                :tabs="[
                  lang('From') + ' ' + startDate.join('-'),
                  lang('到') + ' ' + endDate.join('-')
                ]"
                :confirm-button-text="''"
                :cancel-button-text="''"
                @confirm="onConfirm"
                @cancel="onCancel"
              >
                <van-date-picker
                  v-model="startDate"
                  :min-date="minDate"
                  :max-date="maxDate"
                />
                <van-date-picker
                  v-model="endDate"
                  :min-date="minDate"
                  :max-date="maxDate"
                />
              </van-picker-group>
            </div>
          </div>
          <div class="btnBox">
            <van-button
              plain
              type="default"
              class="reset"
              round
              @click="onCancel"
              >{{ lang('重置') }}</van-button
            >
            <van-button
              class="confirm"
              color="linear-gradient(to right, #FA510F, #FF0000)"
              round
              @click="onConfirm"
            >
              {{ lang('确定') }}
            </van-button>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import FilterBtn from '@/views/shippingCommission/component/filterBtn.vue'
import {
  getDateBeforeDays,
  getFormattedDate,
  getSixMonthsAgoDate,
  isDateDifferenceOver31Days
} from '@/utils/aboutDate'
import lang from '@/langs'
import { showToast } from 'vant'
const emits = defineEmits(['confirm', 'reset'])
const showBottom = ref(false)

const props = defineProps({
  sourceEnum: {
    // 下拉区域始终为全屏的高度
    type: Array,
    default: () => []
  },
  sourceEnumType: {
    // 下拉区域始终为全屏的高度
    type: Array,
    default: () => []
  },
  source: {
    // 下拉区域始终为全屏的高度
    type: Number,
    required: true,
    default: 0
  },
  sourceType: {
    // 下拉区域始终为全屏的高度
    type: Number,
    required: true,
    default: 0
  },
  searchText: {
    // 下拉区域始终为全屏的高度
    type: String,
    required: true

    // default: ''
  },
  startDate: {
    // 下拉区域始终为全屏的高度
    type: Array,
    required: true

    // default: () => getFormattedDate()
  },
  endDate: {
    // 下拉区域始终为全屏的高度
    type: Array,
    required: true

    // default: () => getFormattedDate()
  },
  checked: {
    // 下拉区域始终为全屏的高度
    type: String,
    required: true
    // default: '1'
  }
})
//订单来源
const source = ref(props.source)
//订单来源类型
const sourceType = ref(props.sourceType)
const searchText = ref(props.searchText)
const startDate = ref(props.startDate)
const endDate = ref(props.endDate)
const checked = ref(props.checked)
const minDate = ref(getSixMonthsAgoDate())
const maxDate = ref(new Date())
const onConfirm = () => {
  const isValidDate = isDateDifferenceOver31Days(
    new Date(startDate.value.join('-')),
    new Date(endDate.value.join('-'))
  )
  if (isValidDate) {
    showToast(lang('时间间隔不能超过31天'))
    return
  }
  if (new Date(startDate.value.join('-')) > new Date(endDate.value.join('-'))) {
    showToast(lang('结束日期不能早于开始日期'))
    return
  }
  showBottom.value = false
  const temp = {
    timeType: Number(checked.value),
    timeStart: startDate.value.join('-'),
    timeEnd: endDate.value.join('-'),
    waybillCode: searchText.value,
    orderSourceCode: source.value,
    orderSourceType: sourceType.value
  }
  emits('confirm', temp)
}

const onCancel = () => {
  searchText.value = ''
  source.value = 0
  sourceType.value = 0
  checked.value = '1'
  startDate.value = getFormattedDate()
  endDate.value = getFormattedDate()
  const temp = {
    timeType: Number(checked.value),
    timeStart: startDate.value.join('-'),
    timeEnd: endDate.value.join('-'),
    waybillCode: searchText.value,
    orderSourceCode: source.value,
    orderSourceType: sourceType.value
  }
  emits('reset', temp)
}

const sourceFn = (value: number) => {
  source.value = value
}
const sourceTypeFn = (value: number) => {
  sourceType.value = value
}
const overlay = () => {
  source.value = props.source
  sourceType.value = props.sourceType
  searchText.value = props.searchText
  startDate.value = props.startDate
  endDate.value = props.endDate
  checked.value = props.checked
}
</script>

<style scoped lang="less">
.filter {
  .filterBox {
    :deep(.van-tabs) {
      .van-tabs__wrap {
        display: flex;
        flex-direction: row;
        .van-tabs__nav {
          display: flex;
          flex-direction: row;
          flex: 1;
          .van-tab {
            flex: 2;
            color: rgba(60, 60, 60, 1);
            font-size: 15px;
          }
          .van-tabs__line {
            background: red;
          }
          .van-picker-group__tab-title {
            margin-right: 0;
          }
        }
      }
    }
    .filterBar {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      font-size: 14px;
      padding: 10px 17px;
      width: 100vw;
      align-items: flex-end;
      background: #fff;
      .image {
        width: 17px;
        height: 17px;
        margin-left: 2px;
      }
    }
    .filterMain {
      display: flex;
      flex-direction: column;
      padding: 20px 17px;
      overflow: scroll;
      flex: 1;
      .searchBox {
        p {
          color: #3c3c3c;
          font-size: 15px;
          font-weight: 500;
        }
        .search {
          display: flex;
          flex-direction: row;
          position: relative;
          .icon {
            color: rgba(135, 133, 133, 0.58);
            position: absolute;
            right: 12px;
            bottom: 26px;
            font-size: 20px;
          }
          .searchInput {
            flex: 1;
            border-radius: 5px;
            border: 1px solid #d3d3d3;
            margin-top: 14px;
            margin-bottom: 16px;
            color: #999999;
            padding: 11px;
            font-size: 14px;
          }
        }
      }
      .dateBox {
        margin-top: 20px;
        font-size: 14px;
        :deep(.van-picker) {
          .van-ellipsis {
            font-size: 15px;
          }
        }
      }
    }
    .btnBox {
      padding: 8px;
      display: flex;
      flex-direction: row;
      .reset {
        margin-right: 8px;
        flex: 2;
      }
      .confirm {
        flex: 2;
      }
    }
  }
}
</style>
